export const loginErrorMessage =
  "There is no Innovera account that matches provided login details. Please try again or reset your password";

export const registerErrorMessage =
  "There was an error while creating your account. Please try again or contact support if the issue persists.";
